export default {
  methods: {
    sanitize (text) {
      return text.toString().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
    },
    autocompleteFilter (item, queryText, itemText) {
      queryText = this.sanitize(queryText)
      return this.sanitize(itemText).indexOf(queryText) !== -1
    }
  }
}
